import { FC } from 'react';
import { useNotificationManager } from 'modules/shop/notificationManager/hooks';
import { useNavElement } from '../../hooks';
import { TopNotification } from './TopNotification';

export const TopNotificationContainer: FC = () => {
  const { notifications, clearNotifications } = useNotificationManager();
  const anchorEl = useNavElement();

  return (
    <TopNotification
      notification={notifications[0]}
      anchorEl={anchorEl}
      onClose={clearNotifications}
    />
  );
};
